import { ActionCardModel, QuestionNode, QuestionData } from '@playbooks/action-cards-utils/src'

export default function getQuestionsWithCode(actionCardsModel: ActionCardModel) {
  return actionCardsModel
    .getSearchService()
    .filter(node => node instanceof QuestionNode && !!node.getCode())
    .map(node => node.data) as QuestionData[]
}
